import { IPayloadAction } from 'store/type';
import { IAdminUser, IUser, IUserState } from './types';

export function setUser(
    state: IUserState,
    action: IPayloadAction<IUser>
): IUserState {
    return {
        ...state,
        user: action.payload.employee || action.payload.student,
        sessionLoading: false,
        sessionError: false,
    };
}

export function setAdminUser(
    state: IUserState,
    action: IPayloadAction<IAdminUser>
): IUserState {
    return {
        ...state,
        adminUser: action.payload,
    };
}

export function setCodeSent(state: IUserState): IUserState {
    return {
        ...state,
        codeSent: true,
    };
}

export function setToken(
    state: IUserState,
    action: IPayloadAction<string>
): void {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem('userToken', action.payload);
        }
    } catch (error) {
        // ignore storage write errors (e.g., restricted storage environments)
    }
}

export function setAdminToken(
    state: IUserState,
    action: IPayloadAction<string>
): void {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem('adminToken', action.payload);
        }
    } catch (error) {
        // ignore storage write errors
    }
}

export function logOut(state: IUserState): IUserState {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.removeItem('userToken');
        }
    } catch (error) {
        // ignore storage delete errors
    }
    return {
        ...state,
        user: undefined,
        sessionLoading: false,
        sessionError: false,
        adminUser: undefined,
    };
}
